<template>
  <div class="kw-conversation-message">
    <div class="kw-conversation-message-divider" />
    <IconSupport width="18" height="18" fill="#888888" />
    <p>{{ message.data.text }}</p>
    <div class="kw-conversation-message-divider" />
  </div>
</template>

<script setup lang="ts">
import IconSupport from '@/svg/IconSupport.vue';

defineProps({
  message: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
.kw-conversation-message {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin: 40px 0;

  svg {
    flex-shrink: 0;
  }

  .kw-conversation-message-divider {
    width: 100%;
    background-color: #a4a4a4;
    height: 1px;
  }

  p {
    max-width: 60%;
    margin: 0 auto;
    color: #6b6b6b;
    font-weight: 300;
    font-size: 1.2rem;
    line-height: 1.6rem;
  }
}
</style>
